import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import './common/translations/config';
import { PersistGate } from 'redux-persist/integration/react'
import returnStoreAndPersistor from "../src/redux/store";

const container = document.getElementById('root');
const root = createRoot(container);
const { store, persistor } = returnStoreAndPersistor
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
